module.exports = __webpack_public_path__ + "img/ssyx_37.54591fbd.jpg";